<template>
    <div class="table-row">
        <div class="title-area">
            <div class="img-box">
                <img :src="require(`@/assets/${src}`)" alt="" />
            </div>
            <p class="title">{{ title }}</p>
        </div>
        <div class="content-area">
            <p v-html="content"></p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {},
        content: {},
        src: {},
    },
};
</script>
<style lang="scss" scoped>
.table-row {
    &:first-child {
        border-top: 2px solid var(--black1);
    }

    padding: 23px 60px 23px 0;
    border-bottom: 1px solid var(--border-color1);
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .title-area {
        flex: 0 0 460px;
        padding-left: 55px;
        margin-right: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .img-box {
            width: 100px;
            height: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 25px;
        }

        p.title {
            flex: 1;
            font-family: 'Pretendard', sans-serif;
            font-weight: 700;
            font-size: 24px;
            letter-spacing: -0.025em;
            color: var(--black1);
        }
    }

    .content-area {
        flex: 1 1 auto;

        p {
            font-family: "Pretendard", sans-serif;
            font-size: 18px;
            color: var(--black2);
            letter-spacing: -0.025em;
            font-weight: 400;
            line-height: 1.6;
            word-break: keep-all;
            color: var(--black3);
        }
    }

    @media screen and (max-width: 1280px) {
        .title-area {
            flex: 0 0 40%;
        }
    }

    @media screen and (max-width: 1024px) {
        flex-direction: column;
        align-items: flex-start;
        padding-right: 0;
        padding: 40px 0;

        .title-area {
            padding: 0;
            margin-right: 0;
            margin-bottom: 20px;

            .img-box {
                width: 60px;
                height: 60px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: scale-down;
                }
            }
        }

        br {
            display: none;
        }
    }

    @media screen and (max-width:768px) {
        padding: 20px;

        .title-area {
            flex-direction: column;
            width: 100%;

            .img-box {
                transform: scale(.8);
                margin-right: 0;
            }

            p.title {
                font-size: 18px;
            }
        }

        .content-area p {
            font-size: 16px;
            text-align: center;
        }
    }
}
</style>
